import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/svg/carousel/feeriya.svg'
import _imports_1 from '@/assets/svg/carousel/rosneft.svg'
import _imports_2 from '@/assets/svg/carousel/dyadko.svg'
import _imports_3 from '@/assets/svg/carousel/silver.svg'


const _hoisted_1 = { class: "carousel-wrapper" }
const _hoisted_2 = { class: "d-flex flex-column align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-column align-items-center\"><div class=\"carousel-text size-s c-blue\">Более <b> 1800 клиентов </b> воспользовались нашими</div><div class=\"carousel-text size-s c-blue\">услугами и остались <b> довольны результатом </b></div></div><div class=\"d-flex flex-column align-items-center mt-4 mb-5\"><div class=\"caps-text\">РЕАЛЬНЫЕ выполненные</div><div class=\"caps-text\">ЗАДАЧИ НАШИХ КЛИЕНТОВ</div></div>", 2)
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = {
  key: 0,
  class: "carousel-card",
  style: {"transform":"scale(0.75)","opacity":"0.2"}
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<img class=\"img-carousel-feeriya\" src=\"" + _imports_0 + "\"><div class=\"carousel-text size-m c-green mb-2\">Кейс №4</div><b class=\"carousel-text size-l\">Студия флористического дизайна Феерия</b><div class=\"carousel-text size-s mt-2\">Компания занимается продажей и доставкой цветов</div><div class=\"carousel-text size-m mt-2\"><b> Проблема: </b> Начали появляться проблемы с онлайн-платежами. После введение в бизнес услуги доставки курьером, собственник понял, что пора автоматизировать продажи</div><div class=\"d-flex justify-content-end\"><div class=\"carousel-text size-xs c-blue me-3\">читать далее...</div></div>", 6)
const _hoisted_13 = [
  _hoisted_7
]
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<img class=\"img-carousel-rosneft\" src=\"" + _imports_1 + "\"><div class=\"carousel-text size-m c-green\">Кейс №1</div><b class=\"carousel-text size-l\">Компания «Роснефть»</b><div class=\"carousel-text size-s\">Компания занимается добычей и реализацией нефти, газа и продуктов их переработки</div><div class=\"carousel-text size-m mt-2\"><b> Проблема: </b> Бухгалтер компании работал удаленно, а реализация продукции и основных средств происходила на широкой географии. Чеки необходимо было выбивать и выдавать каждому покупателю</div>", 5)
const _hoisted_19 = { class: "d-flex justify-content-end" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<img class=\"img-carousel-dyadko\" src=\"" + _imports_2 + "\" alt=\"Google Images\" title=\"Google Images\"><div class=\"carousel-text size-m c-green\">Кейс №2</div><b class=\"carousel-text size-l\">Интернет-магазин «Дядько»</b><div class=\"carousel-text size-s\">Компания занимается продажей ювелирных украшений из родированного серебра</div><div class=\"carousel-text size-m mt-2\"><b> Проблема: </b> Многие из их покупателей являются ИП или подотчетными лицами и имеют строгую отчетность, поэтому необходимо было решить вопрос с автоматической отправкой чеков, после оплаты заказа</div>", 5)
const _hoisted_25 = { class: "d-flex justify-content-end" }
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<img class=\"img-carousel-silver\" src=\"" + _imports_3 + "\"><div class=\"carousel-text size-m c-green mb-2\"> Кейс №3</div><b class=\"carousel-text size-l\">Интернет-магазин «Pigeon Silver»</b><div class=\"carousel-text size-s my-2\">Компания занимается продажей ювелирных украшений из родированного серебра</div><div class=\"carousel-text size-m\"><b> Проблема: </b> Большая доля продаж приходится на онлайн-заказы в соц.сетях, поэтому необходимо было автоматизировать процесс онлайн-оплаты</div>", 5)
const _hoisted_31 = { class: "d-flex justify-content-end" }
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<img class=\"img-carousel-feeriya\" src=\"" + _imports_0 + "\"><div class=\"carousel-text size-m c-green mb-2\">Кейс №4</div><b class=\"carousel-text size-l\">Студия флористического дизайна Феерия</b><div class=\"carousel-text size-s mt-2\">Компания занимается продажей и доставкой цветов</div><div class=\"carousel-text size-m mt-2\"><b> Проблема: </b> Начали появляться проблемы с онлайн-платежами. После введение в бизнес услуги доставки курьером, собственник понял, что пора автоматизировать продажи</div>", 5)
const _hoisted_37 = { class: "d-flex justify-content-end" }
const _hoisted_38 = {
  key: 5,
  class: "carousel-card",
  style: {"transform":"scale(0.75)","opacity":"0.2"}
}
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<img class=\"img-carousel-rosneft\" src=\"" + _imports_1 + "\"><div class=\"carousel-text size-m c-green\">Кейс №1</div><b class=\"carousel-text size-l\">Компания «Роснефть»</b><div class=\"carousel-text size-s\">Компания занимается добычей и реализацией нефти, газа и продуктов их переработки</div><div class=\"carousel-text size-m mt-2\"><b> Проблема: </b> Бухгалтер компании работал удаленно, а реализация продукции и основных средств происходила на широкой географии. Чеки необходимо было выбивать и выдавать каждому покупателю</div><div class=\"d-flex justify-content-end\"><div class=\"carousel-text size-xs c-blue me-3\">читать далее... </div></div>", 6)
const _hoisted_45 = [
  _hoisted_39
]
const _hoisted_46 = { class: "d-flex justify-content-center mt-3 mb-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("b", { class: "carousel-text size-xl" }, "90% клиентов - постоянные", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SlideLarge = _resolveComponent("SlideLarge")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.selectedSlide === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_13))
            : _createCommentVNode("", true),
          (_ctx.selectedSlide === 1 || _ctx.selectedSlide === 2)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "carousel-card",
                style: _normalizeStyle(_ctx.selectedSlide !== 1 ? 'transform: scale(0.75); opacity: 0.2;' : '')
              }, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: "carousel-text size-xs c-blue me-3",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openBox(1)))
                  }, "читать далее...")
                ])
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.selectedSlide === 2 || _ctx.selectedSlide === 3 || _ctx.selectedSlide === 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "carousel-card",
                style: _normalizeStyle(_ctx.selectedSlide !== 2 ? 'transform: scale(0.75); opacity: 0.2;' : '')
              }, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", {
                    class: "carousel-text size-xs c-blue me-3",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openBox(2)))
                  }, "читать далее...")
                ])
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.selectedSlide === 3 || _ctx.selectedSlide === 2  || _ctx.selectedSlide === 4)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "carousel-card",
                style: _normalizeStyle(_ctx.selectedSlide !== 3 ? 'transform: scale(0.75); opacity: 0.2;' : '')
              }, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", {
                    class: "carousel-text size-xs c-blue me-3",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openBox(3)))
                  }, "читать далее...")
                ])
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.selectedSlide === 4 || _ctx.selectedSlide === 3)
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: "carousel-card",
                style: _normalizeStyle(_ctx.selectedSlide !== 4 ? 'transform: scale(0.75); opacity: 0.2;' : '')
              }, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", {
                    class: "carousel-text size-xs c-blue me-3",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openBox(4)))
                  }, "читать далее...")
                ])
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.selectedSlide === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_45))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("input", {
            class: "carousel__radio",
            type: "radio",
            id: "slide1",
            value: "slide1",
            name: "carousel",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeSlide(1, 'manual'))),
            checked: ""
          }, null, 32),
          _createElementVNode("input", {
            class: "carousel__radio",
            type: "radio",
            id: "slide2",
            value: "slide2",
            name: "carousel",
            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeSlide(2, 'manual')))
          }, null, 32),
          _createElementVNode("input", {
            class: "carousel__radio",
            type: "radio",
            id: "slide3",
            value: "slide3",
            name: "carousel",
            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeSlide(3, 'manual')))
          }, null, 32),
          _createElementVNode("input", {
            class: "carousel__radio",
            type: "radio",
            id: "slide4",
            value: "slide4",
            name: "carousel",
            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeSlide(4, 'manual')))
          }, null, 32)
        ]),
        _hoisted_47
      ])
    ]),
    _createVNode(_component_SlideLarge, {
      modelValue: _ctx.showSlideLarge,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showSlideLarge) = $event)),
      number: _ctx.slideNumber
    }, null, 8, ["modelValue", "number"])
  ], 64))
}